import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { MenuSection } from "../../../@types/stores/menu";
import menuStore from "../../../stores/menu";
import lodash from "lodash";
import {ReactComponent as IconArrow} from "../../../assets/icons/arrow.svg";


const HeaderMenuSubCategories = () => {

    const [subCategories, setSubCategories] = useState<MenuSection[]>([]);

    useEffect(() => {
        getSubCategories();

        const itemsDom = document.querySelector(".HeaderMenuSubCategories .items");
        if (itemsDom)
            itemsDom.addEventListener("scroll", checkOpacity);

        return () => {
            if (itemsDom)
                itemsDom.removeEventListener("scroll", checkOpacity);
        }
    }, []);

    useEffect(() => {
        checkOpacity();
    }, [subCategories]);

    useEffect(() => {
        getSubCategories();
        // eslint-disable-next-line
    }, [menuStore.activeCategory]);

    const getSubCategories = async () => {
        if (!menuStore.menu)
            await menuStore.getMenu();

        const category = menuStore.menu?.find(x => x.id === menuStore.navigation.category);

        if (category?.submenu?.length) {
            const subCats: MenuSection[] = [];

            category.submenu.forEach(x => {
                const subCategory = lodash.cloneDeep(x);
                delete subCategory.articles;
                subCats.push(subCategory);
            });
            setSubCategories(subCats);
        }
    }

    const moveNext = () => {
        const itemsDom = document.querySelector(".HeaderMenuSubCategories .items");
        
        if (itemsDom) {
            const endScroll = itemsDom.scrollWidth - itemsDom.clientWidth;

            if (itemsDom.scrollLeft < endScroll) {
                const to = itemsDom.scrollLeft + 200 < endScroll ? itemsDom.scrollLeft + 200 : endScroll;
                itemsDom.scrollTo(to , 0);
            }
        }
    }

    const movePrev = () => {
        const itemsDom = document.querySelector(".HeaderMenuSubCategories .items");
        
        if (itemsDom) {
            if (itemsDom.scrollLeft > 0) {
                const to = itemsDom.scrollLeft - 200 > 0 ? itemsDom.scrollLeft - 200 : 0;
                itemsDom.scrollTo(to, 0);
            }
        }
    }

    const checkOpacity = () => {
        const itemsDom = document.querySelector(".HeaderMenuSubCategories .items");
        if (itemsDom) {
            const endScroll = itemsDom.scrollWidth - itemsDom.clientWidth;
            if (endScroll === 0) {
                itemsDom.classList.remove("hasPrev");
                itemsDom.classList.remove("hasPrevNext");
                itemsDom.classList.add("hasNext");
    
                const prevArrowDom = document.querySelector(".HeaderMenuSubCategories .arrow.left");
                if (prevArrowDom)
                    prevArrowDom.classList.add("invisible");
    
                const nextArrowDom = document.querySelector(".HeaderMenuSubCategories .arrow.right");
                if (nextArrowDom)
                    nextArrowDom.classList.add("invisible");
                return;
            }

            if (endScroll === itemsDom.scrollLeft) {
                itemsDom.classList.remove("hasNext");
                itemsDom.classList.remove("hasPrevNext");
                itemsDom.classList.add("hasPrev");

                const nextArrowDom = document.querySelector(".HeaderMenuSubCategories .arrow.right");
                if (nextArrowDom)
                    nextArrowDom.classList.add("invisible");

                const prevArrowDom = document.querySelector(".HeaderMenuSubCategories .arrow.left");
                if (prevArrowDom)
                    prevArrowDom.classList.remove("invisible");
            }
            else if (0 === itemsDom.scrollLeft) {
                itemsDom.classList.remove("hasPrev");
                itemsDom.classList.remove("hasPrevNext");
                itemsDom.classList.add("hasNext");
    
                const prevArrowDom = document.querySelector(".HeaderMenuSubCategories .arrow.left");
                if (prevArrowDom)
                    prevArrowDom.classList.add("invisible");
    
                const nextArrowDom = document.querySelector(".HeaderMenuSubCategories .arrow.right");
                if (nextArrowDom)
                    nextArrowDom.classList.remove("invisible");
            }
            else {
                itemsDom.classList.remove("hasNext");
                itemsDom.classList.remove("hasPrev");

                if (!itemsDom.classList.contains("hasPrevNext"))
                    itemsDom.classList.add("hasPrevNext");

                
                const nextArrowDom = document.querySelector(".HeaderMenuSubCategories .arrow.right");
                if (nextArrowDom && nextArrowDom.classList.contains("invisible"))
                    nextArrowDom.classList.remove("invisible");

                const prevArrowDom = document.querySelector(".HeaderMenuSubCategories .arrow.left");
                if (prevArrowDom && prevArrowDom.classList.contains("invisible"))
                    prevArrowDom.classList.remove("invisible");
            }
        }
    }

    const changeSubCategory = (subCategory: MenuSection) => {
        menuStore.changeSubCategory(subCategory.id, true);
    }

    return <div className="HeaderMenuSubCategories">
        <div className="arrow left invisible" onClick={movePrev}>
            <IconArrow />
        </div>
        <div className="items">
            {subCategories.map(x => <div key={x.name} className={`item ${x.id === menuStore.navigation.subCategory ? "active" : ""}`} onClick={() => changeSubCategory(x)}>
                {x.name}
            </div>)}
        </div>
        <div className="arrow right invisible" onClick={moveNext}>
            <IconArrow />
        </div>
    </div>
}

export default observer(HeaderMenuSubCategories);